import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Globals } from 'src/app/Globals';
import { HttpService } from '../../../services/http-service';
import { getSignupUserId, patchSignupProgress } from '../signup-user';

@Component({
  selector: 'app-tcp-and-insurance',
  templateUrl: './tcp-and-insurance.component.html',
  styleUrls: ['./tcp-and-insurance.component.scss']
})
export class TCPAndInsuranceComponent implements OnInit {
  uploadingImage: boolean;
  fileToUpload: any;
  globals = Globals;
  model: any = {};
  isLoadingResults = false;
  pdf = false;
  uploadedFileName = '';
  rForm: FormGroup;
  constructor(private fb: FormBuilder, private service: HttpService, private router: Router) { }
  get rFormControls() { return this.rForm.controls; }

  ngOnInit() {
    this.rForm = this.fb.group({
      tcpNumber: ['', Validators.required],
      commercialInsuranceNumber: ['', Validators.required],
      commercialInsuranceDocument: ['', Validators.required],
      check: [false]
    });
    if (!getSignupUserId()) {
      this.service.showError('Please complete registration first.', 'ERROR');
      this.router.navigate(['/registration/registration-details']);
    }
  }

  private errorMessage(err: any): string {
    if (!err) {
      return 'Upload failed. Please try again.';
    }
    if (typeof err === 'string') {
      return err;
    }
    if (err.message) {
      return err.message;
    }
    if (err.error && err.error.message) {
      return err.error.message;
    }
    return 'Upload failed. Please try again.';
  }

  uploadImage(files: FileList, type) {
    if (!files || !files.length) {
      return;
    }

    if (files[0].type === 'image/gif') {
      this.service.showError('Gif images are not allowed', 'Sign Up');
      return;
    }
    if (files[0].size > 5000000) {
      this.service.showError('Image size should be less then 5MB');
      return;
    }

    const file = files[0].name.substring(files[0].name.lastIndexOf('.'));
    const isPdf = file.toLowerCase() === '.pdf';
    const url = isPdf
      ? this.globals.urls.signUp.noauth.uploadPDF
      : this.globals.urls.signUp.noauth.uploadImage;

    this.uploadingImage = true;
    this.fileToUpload = files.item(0);
    this.isLoadingResults = true;

    this.service.uploadImage(url, this.fileToUpload).subscribe(
      res => {
        this.uploadingImage = false;
        this.isLoadingResults = false;

        const uploadedUrl = res && res.data && res.data.url;
        if (!uploadedUrl) {
          this.pdf = false;
          this.uploadedFileName = '';
          this.service.showError((res && res.message) || 'Document upload failed', 'Sign Up');
          return;
        }

        if (type === 1) {
          this.model.serviceImage = uploadedUrl;
        } else {
          this.model.dashboardImage = uploadedUrl;
        }

        this.pdf = isPdf;
        this.uploadedFileName = files[0].name || (isPdf ? 'Doc.pdf' : 'Document');
        this.rForm.patchValue({ commercialInsuranceDocument: uploadedUrl });
        this.rForm.get('commercialInsuranceDocument').markAsDirty();
      },
      err => {
        this.uploadingImage = false;
        this.isLoadingResults = false;
        this.pdf = false;
        this.uploadedFileName = '';
        this.service.showError(this.errorMessage(err), 'Sign Up');
      },
    );
  }

  goToNextStep() {
    const userId = getSignupUserId();
    if (!userId) {
      this.service.showError('Please complete registration first.', 'ERROR');
      this.router.navigate(['/registration/registration-details']);
      return;
    }

    if (this.rForm.invalid || !this.model.serviceImage) {
      Object.keys(this.rForm.controls).forEach(key => {
        this.rForm.controls[key].markAsTouched();
      });
      this.service.showError('Please fill all required fields and upload the insurance document.', 'Sign Up');
      return;
    }

    const params = {
      _id: userId,
      merchantId: userId,
      tcpNumber: this.rForm.controls['tcpNumber'].value,
      commercialInsuranceNumber: this.rForm.controls['commercialInsuranceNumber'].value,
      commercialInsuranceDocumentUrl: this.model.serviceImage,
      isSameCommercialInsuranceDocumentForAllCars: this.rForm.controls['check'].value,
    };
    const url = this.globals.urls.signUp.noauth.companyInsurance;
    this.isLoadingResults = true;
    this.service.putRequest(url, params).subscribe(
      res => {
        this.isLoadingResults = false;
        if (res.success === 1) {
          this.service.showSuccess(res.message, 'SignUp');
          patchSignupProgress({ signupStepCompleted: 3, isSignupCompleted: true });
          this.router.navigate(['/registration/vehicles']);
        } else {
          this.service.showError(res.message, 'SignUp ERROR');
        }
      },
      err => {
        this.isLoadingResults = false;
        this.service.showError(this.errorMessage(err), 'ERROR');
      }
    );
  }

}
